// extracted by mini-css-extract-plugin
export var banner = "_m8-0";
export var settingRow = "_m8-2";
export var titleIcon = "_m8-1";